import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  idSelectedCandidate?: string;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  idSelectedCandidate: undefined,
  data: {},
};

const forwardEvaluationSlice = createSlice({
  name: "forwardEvaluation",
  initialState,
  reducers: {
    updateIdSelectedCandidate: (state, action) => {
      state.idSelectedCandidate = action.payload;
    },
    getInfoSelectedCandidateStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getInfoSelectedCandidateSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      Object.assign(state.data, action.payload.data);
    },
    getInfoSelectedCandidateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetInfoSelectedCandidate: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = {};
      state.idSelectedCandidate = undefined;
    },
    updateReviewCandidate: (state, action) => {
      Object.assign(state.data, action.payload);
    },
  },
});

export const {
  updateIdSelectedCandidate,
  getInfoSelectedCandidateStart,
  getInfoSelectedCandidateSuccess,
  getInfoSelectedCandidateFailed,
  resetInfoSelectedCandidate,
  updateReviewCandidate,
} = forwardEvaluationSlice.actions;

export default forwardEvaluationSlice.reducer;
